// Copyright (c) 2024 - Present. Hardfin, Inc. All rights reserved.
// Hardfin Confidential - Restricted
import logo from '@/assets/logo.png';
import { Box } from '@mui/material';

/**
 * A component that renders a fullscreen splash image with the Hardfin logo.
 */
export function SplashScreen() {
  return (
    <Box
      display="flex"
      alignItems="center"
      justifyContent="center"
      bgcolor="background.default"
      position="fixed"
      height="100vh"
      width="100vw"
      zIndex={2000}
      top={0}
      left={0}
    >
      <img src={logo} height="40px" width="auto" />
    </Box>
  );
}
